import { createAction } from '@ngrx/store';

const unsubscribeBeforeLogout = createAction('[Header] Unsuscribe to All topic before logout');

export const OfferHeaderActions = {
  unsubscribeBeforeLogout,
};
